import request from '@/utils/request';

export type ConnectionStatus = {
  available: boolean;
  status?: 'disconnected' | 'connected' | 'expired' | 'unavailable';
  displayName?: string;
  navigationLabel?: string;
  rootLabel?: string;
  sharePointUrl?: string;
  markdownLinkEnabled?: boolean;
  configurationValid?: boolean;
};

export type Root = {
  id: string;
  name: string;
  displayLabel: string;
  sharePointUrl?: string;
};

export type DocsItem = {
  id: string;
  name: string;
  kind: 'folder' | 'file';
  lastModifiedDateTime?: string;
  size?: number;
};

export type ChildrenPage = {
  items: DocsItem[];
  nextCursor?: string;
};

export type LinkResult = {
  url: string;
  markdown?: string;
};

const csrfConfig = {
  headers: {
    'X-Answer-Docs-CSRF': '1',
  },
};

export const getConnection = (probe = true) =>
  request.get<ConnectionStatus>(
    `/answer/api/v1/docs/connection?probe=${probe ? '1' : '0'}`,
  );

export const beginConnection = () =>
  request.post<{ authorizationUrl: string }>(
    '/answer/api/v1/docs/connect',
    {},
    csrfConfig,
  );

export const disconnect = () =>
  request.post('/answer/api/v1/docs/disconnect', {}, csrfConfig);

export const getRoot = () =>
  request.get<Root>('/answer/api/v1/docs/root');

export const getChildren = (itemId: string, cursor?: string) => {
  const query = cursor ? `?cursor=${encodeURIComponent(cursor)}` : '';
  return request.get<ChildrenPage>(
    `/answer/api/v1/docs/items/${encodeURIComponent(itemId)}/children${query}`,
  );
};

export const getLink = (itemId: string) =>
  request.post<LinkResult>(
    `/answer/api/v1/docs/items/${encodeURIComponent(itemId)}/link`,
    {},
    csrfConfig,
  );
